

const navigation = () => {
  return [
    {
      title: 'Home',
      path: '/'
    },
    {
      title: 'Our Solution',
      path: '/#our-solution'
    },
    {
      title: 'How it works',
      path: '/#how-it-works'
    },
    {
      title: 'Prompt Library ',
      path: '/our-prompt'
    },
    {
      title: 'Subscriptions',
      path: '/our-price'
    },
    {
      title: 'Consultants',
      path: '/our-consultants'
    },
    {
      title: 'Contact',
      path: '/our-contact'
    }
  ];
};

export default navigation;


